import { render, staticRenderFns } from "./MPhotos.vue?vue&type=template&id=705de88e"
import script from "./MPhotos.vue?vue&type=script&lang=js"
export * from "./MPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports